import { correctNodes as D } from "./utils/correctFocus.js";
import { pickFocusable as I } from "./utils/firstFocus.js";
import { isGuard as G } from "./utils/is.js";
var p = "NEW_FOCUS", _ = function(i, a, t, n, d) {
  var x = i.length, o = i[0], M = i[x - 1], e = G(n);
  if (!(n && i.indexOf(n) >= 0)) {
    var f = n !== void 0 ? t.indexOf(n) : -1, g = d ? t.indexOf(d) : f, r = d ? i.indexOf(d) : -1;
    if (f === -1)
      return r !== -1 ? r : p;
    if (r === -1)
      return p;
    var u = f - g, v = t.indexOf(o), O = t.indexOf(M), c = D(t), s = n !== void 0 ? c.indexOf(n) : -1, C = s - (d ? c.indexOf(d) : f);
    if (!u && r >= 0 || a.length === 0)
      return r;
    var h = I(i, a[0]), F = I(i, a[a.length - 1]);
    if (f <= v && e && Math.abs(u) > 1)
      return F;
    if (f >= O && e && Math.abs(u) > 1)
      return h;
    if (u && Math.abs(C) > 1)
      return r;
    if (f <= v)
      return F;
    if (f > O)
      return h;
    if (u)
      return Math.abs(u) > 1 ? r : (x + r + u) % x;
  }
};
export {
  p as NEW_FOCUS,
  _ as newFocus
};
//# sourceMappingURL=solver.js.map
